module.exports = __webpack_public_path__ + "static/media/2.280d445.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/2.mp3
// module id = m2cP
// module chunks = 0